import { render } from "./ApprovedTransfers.vue?vue&type=template&id=c74df2bc"
import script from "./ApprovedTransfers.vue?vue&type=script&lang=js"
export * from "./ApprovedTransfers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__